import fetcher, {FileDownloadRequest} from './fetcher'
import newFetcher from './newFetcher'

export const normalRequest = async <Model extends CommonResponse>(
  request: ApiRequest,
): Promise<Model> => fetcher.request(request)

const withRefreshRequest = async <Model extends CommonResponse>(
  request: ApiRequest,
): Promise<Model> => fetcher.authedRequest(request)

export default withRefreshRequest

export const fileRequest = async <Model extends CommonResponse>(
  request: ApiRequest,
): Promise<Model> => fetcher.fileRequest(request)

export const fileDownload = async (request: FileDownloadRequest) =>
  fetcher.fileDownload(request)

export const hasResponseFileDownload = async (
  request: FileDownloadRequest,
): Promise<boolean> => fetcher.hasResponseFileDownload(request)

export const fileDownloadData = async (request: FileDownloadRequest) =>
  fetcher.fileDownloadDataResponse(request)

export const newRequest = async <T>(request: ApiRequest): Promise<T> =>
  newFetcher.newRequest(request)

export const newNormalRequest = async <T>(request: ApiRequest): Promise<T> =>
  newFetcher.newAuthedRequest(request)

export const newFileRequest = async <Model extends CommonResponse>(
  request: ApiRequest,
): Promise<Model> => newFetcher.newFileRequest(request)

export const textRequest = async <Model>(request: ApiRequest): Promise<Model> =>
  fetcher.requestText(request)

export const shopRequest = async <Model extends ShopCommonResponse>(
  request: ApiRequest,
): Promise<Model> => fetcher.shopRequest(request)

export const uploadS3Request = async (request: ApiRequest) =>
  fetcher.fileUploadS3(request)

export const uploadGoodAttachmentRequest = async (request: ApiRequest) =>
  fetcher.goodAttachmentUploadS3(request)

export const noCommonResponseRequest = async <T>(
  request: ApiRequest,
): Promise<T> => fetcher.noCommonResponseRequest(request)
